import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";

function Selectbox({
  id,
  name,
  onChange,
  errors,
  errorKey,
  classes = "",
  fieldValue = "",
  options = [],
  formErrorClass = "form-error"
}) {
  const [formError, setFormError] = useState("");
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors.length") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <span>
      <select
        id={id}
        name={name}
        value={fieldValue}
        className={`form-input ${classes} ${formError}`}
        onChange={e => {
          onInputChange(e);
          onChange(e);
        }}
      >
        {options.map((option, idx) => (
          <option key={idx} value={option.value}>
            {option.label || option.value}
          </option>
        ))}
      </select>
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </span>
  );
}

Selectbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  classes: PropTypes.string,
  fieldValue: PropTypes.string,
  options: PropTypes.array,
  formErrorClass: PropTypes.string
};

export default Selectbox;
